import axios from 'axios';
import { IStatusResponse } from '@/dealroom/integrations/google/types/status-response';
import { IWordMergeField } from '@/dealroom/integrations/word/types/word-merge-field';
import { IWordUploadResponse } from '@/dealroom/integrations/word/types/word-upload-response';
import { IProcessWordResponse } from '@/dealroom/integrations/word/types/process-word-response';
import { IWordTemplateResponse } from '@/dealroom/integrations/word/types/word-template-response';

export default class WordService {
  static async upload(file: File): Promise<IWordUploadResponse> {
    const body = new FormData();
    body.append('file', file);
    const { data } = await axios.post('/save/upload', body);
    return data;
  }

  static async process(
    documentId: string,
    fileName: string,
    missing: IWordMergeField[],
    index: number
  ): Promise<IProcessWordResponse> {
    const body = new FormData();
    body.append('action', 'process-word');
    body.append('document-id', documentId);
    body.append('upload-file-list', fileName);
    body.append('index', index.toString());
    missing.forEach((mergeField: IWordMergeField) => {
      body.append(`merge[${mergeField.name}]`, mergeField.value);
    });
    const { data } = await axios.post('/save/document', body);
    return data;
  }

  static async saveImportLog(documentId: string): Promise<IStatusResponse> {
    const body = new FormData();
    body.append('action', 'import-log');
    body.append('document-id', documentId);
    body.append('file-src', 'word');
    const { data } = await axios.post('/save/document', body);
    return data;
  }

  static async saveWordTemplate(
    documentId: string,
    fileName: string,
    index: number
  ): Promise<IWordTemplateResponse> {
    const body = new FormData();
    body.append('action', 'save-word-template');
    body.append('document-id', documentId);
    body.append('upload-file-list', fileName);
    body.append('index', index.toString());

    const { data } = await axios.post('/save/document', body);
    return {
      ...data,
      externalEditorType: data.external_editor_type,
    };
  }
}
